var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      !_vm.hideExtras
        ? _c(
            "actionBarComponent",
            {
              attrs: {
                slots: 7,
                showSave: !_vm.somenteConsulta,
                title: _vm.$t("__.Crud.cliente.edit_vue_html.clienteEdit"),
              },
              on: { onSave: _vm.save },
              scopedSlots: _vm._u([
                {
                  key: "buttonSlot4",
                  fn: function (ref) {
                    var open = ref.open
                    return _vm.modelId
                      ? _c(
                          "div",
                          {
                            attrs: {
                              title: _vm.$t("__.ts.historicoAlteracoes"),
                            },
                            on: {
                              click: function ($event) {
                                open(
                                  1,
                                  _vm.$t("__.ts.historicoAlteracoes"),
                                  "lg-modal"
                                )
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-history",
                              attrs: { slot: "button", "aria-hidden": "true" },
                              slot: "button",
                            }),
                          ]
                        )
                      : _vm._e()
                  },
                },
              ]),
            },
            [
              _vm.model.id
                ? _c(
                    "div",
                    {
                      attrs: {
                        slot: "buttonSlot0",
                        title: _vm.$t("__.ts.visuVendasClient"),
                      },
                      on: { click: _vm.onOpenVendasModal },
                      slot: "buttonSlot0",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-clipboard-list",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.validarVisibilidadeBotoes("replicar-filiais")
                ? _c(
                    "div",
                    {
                      attrs: {
                        slot: "buttonSlot1",
                        title: _vm.$t("__.ts.replicarFiliais"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.onReplicarFiliais()
                        },
                      },
                      slot: "buttonSlot1",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-clone",
                        attrs: { slot: "button", "aria-hidden": "true" },
                        slot: "button",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.model.id
                ? _c(
                    "div",
                    {
                      attrs: {
                        slot: "buttonSlot2",
                        title: _vm.$t("__.Crud.imprimir"),
                      },
                      on: { click: _vm.print },
                      slot: "buttonSlot2",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-print",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.model.id &&
              _vm.VALIDAR_PERMISSAO_USUARIO("clientes", "delete")
                ? _c(
                    "div",
                    {
                      attrs: {
                        slot: "buttonSlot3",
                        title: _vm.$t("__.Crud.excluir"),
                      },
                      on: { click: _vm.onDelete },
                      slot: "buttonSlot3",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-times",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: {
                    slot: "buttonSlot5",
                    title: _vm.$t(
                      "__.Crud.cliente.edit_vue_html.anexarArquivo"
                    ),
                  },
                  on: { click: _vm.onShowUploadAnexo },
                  slot: "buttonSlot5",
                },
                [
                  _c("i", {
                    staticClass: "fa fa-paperclip",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.model.id
                ? _c(
                    "div",
                    {
                      attrs: {
                        slot: "buttonSlot6",
                        title: _vm.$t(
                          "__.ts.informacoesAdicionaisRepresentante"
                        ),
                      },
                      on: {
                        click: _vm.onShowInformacoesAdicionaisRepresentante,
                      },
                      slot: "buttonSlot6",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-info",
                        attrs: { slot: "button", "aria-hidden": "true" },
                        slot: "button",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modalSlot1" }, slot: "modalSlot1" },
                [
                  _c("logEntidadeComponent", {
                    attrs: { registroId: _vm.modelId, entidade: 11 },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.dadosGerais"),
                collapsed: false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows", id: "cliente" }, slot: "rows" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("tipoPessoa"),
                              expression: "errors.first('tipoPessoa')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: {
                                for: "tipoPessoa",
                                title: _vm.$t("__.obrigatorio"),
                              },
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("__.Crud.cliente.edit_vue_html.tipo")
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            directives: [
                              { name: "focus", rawName: "v-focus" },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "tipoPessoa",
                              name: "tipoPessoa",
                              data: _vm.tiposPessoaOptions,
                              searchable: false,
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.tipoPessoa,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "tipoPessoa", $$v)
                              },
                              expression: "model.tipoPessoa",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    (!_vm.model.exterior &&
                      _vm.model.tipoPessoa == _vm.tiposPessoa.Fisica) ||
                    _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                      ? _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("cpf"),
                                  expression: "errors.first('cpf')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "cpf" },
                                },
                                [
                                  _vm.cpfObrigatorio
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.cpf"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("cpf-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: _vm.cpfObrigatorio,
                                      cpf: true,
                                    },
                                    expression:
                                      "{ required: cpfObrigatorio, cpf: true }",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "cpf",
                                  name: "cpf",
                                  disabled: _vm.somenteConsulta,
                                },
                                on: { input: _vm.onBlurCpf },
                                model: {
                                  value: _vm.model.cpf,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "cpf", $$v)
                                  },
                                  expression: "model.cpf",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.model.exterior &&
                      _vm.model.tipoPessoa == _vm.tiposPessoa.Fisica) ||
                    _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                      ? _c("div", { staticClass: "col-sm-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first(
                                    "orgaoEmissaoCpfSNGPC"
                                  ),
                                  expression:
                                    "errors.first('orgaoEmissaoCpfSNGPC')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "orgaoEmissaoCpfSNGPC" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.orgaoEmissorCpf"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "orgaoEmissaoCpfSNGPC",
                                  name: "orgaoEmissaoCpfSNGPC",
                                  data: _vm.orgaoEmissaoCpfSNGPCOptions,
                                  searchable: true,
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.orgaoEmissaoCpfSNGPC,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "orgaoEmissaoCpfSNGPC",
                                      $$v
                                    )
                                  },
                                  expression: "model.orgaoEmissaoCpfSNGPC",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.model.exterior &&
                    _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica
                      ? _c("div", { staticClass: "col-sm-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("cnpj"),
                                  expression: "errors.first('cnpj')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "cnpj",
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.cnpj"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("cnpj-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        cnpj: true,
                                        required:
                                          !_vm.model.exterior &&
                                          _vm.model.tipoPessoa ==
                                            _vm.tiposPessoa.Juridica,
                                      },
                                    },
                                    expression:
                                      "{\n                                    rules: {\n                                        cnpj: true,\n                                        required: !model.exterior && model.tipoPessoa == tiposPessoa.Juridica,\n                                    },\n                                }",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "cnpj",
                                  name: "cnpj",
                                  disabled: _vm.somenteConsulta,
                                },
                                on: { input: _vm.onBlurCnpj },
                                model: {
                                  value: _vm.model.cnpj,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "cnpj", $$v)
                                  },
                                  expression: "model.cnpj",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.model.exterior &&
                      _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica) ||
                    _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                      ? _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("inscricaoEstadual"),
                                  expression:
                                    "errors.first('inscricaoEstadual')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "inscricaoEstadual" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.ie"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("data-tooltip-component", {
                                attrs: {
                                  text: _vm.$t(
                                    "__.Crud.cliente.edit_vue_html.clientIsentoEmBranco"
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.inscricaoEstadual,
                                    expression: "model.inscricaoEstadual",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "inscricaoEstadual|max:20",
                                    expression: "'inscricaoEstadual|max:20'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  id: "inscricaoEstadual",
                                  name: "inscricaoEstadual",
                                  placeholder: "___-_______",
                                  disabled: _vm.somenteConsulta,
                                },
                                domProps: {
                                  value: _vm.model.inscricaoEstadual,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "inscricaoEstadual",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.model.exterior
                      ? _c("div", { staticClass: "col-sm-1" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("ufEmissaoCpf"),
                                  expression: "errors.first('ufEmissaoCpf')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "ufEmissaoCpf" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.model.tipoPessoa ==
                                          _vm.tiposPessoa.Juridica
                                          ? _vm.$t(
                                              "__.Crud.cliente.edit_vue_html.ufEmissaoCnpj"
                                            )
                                          : _vm.$t(
                                              "__.Crud.cliente.edit_vue_html.ufEmissaoCpf"
                                            )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "ufEmissaoCpf",
                                  name: "ufEmissaoCpf",
                                  data: _vm.ufOptions,
                                  searchable: true,
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.ufEmissaoCpf,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "ufEmissaoCpf", $$v)
                                  },
                                  expression: "model.ufEmissaoCpf",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.model.exterior &&
                    _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica
                      ? _c("div", { staticClass: "col-sm-1" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first(
                                    "contribuinteEstadual"
                                  ),
                                  expression:
                                    "errors.first('contribuinteEstadual')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "contribuinteEstadual" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.contribuinteEstadual"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("checkbox-component", {
                                attrs: {
                                  id: "contribuinteEstadual",
                                  name: "contribuinteEstadual",
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.contribuinteEstadual,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "contribuinteEstadual",
                                      $$v
                                    )
                                  },
                                  expression: "model.contribuinteEstadual",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model.exterior
                      ? _c("div", { staticClass: "col-sm-8" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("idEstrangeiro"),
                                  expression: "errors.first('idEstrangeiro')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "idEstrangeiro",
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.documentoEstrangeiro"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("data-tooltip-component", {
                                attrs: {
                                  text: "Número do passaporte, ou outro documento legal do estrangeiro",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.idEstrangeiro,
                                    expression: "model.idEstrangeiro",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  id: "idEstrangeiro",
                                  name: "idEstrangeiro",
                                  disabled: _vm.somenteConsulta,
                                },
                                domProps: { value: _vm.model.idEstrangeiro },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "idEstrangeiro",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-1" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("exterior"),
                              expression: "errors.first('exterior')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "exterior" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.exterior"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("checkbox-component", {
                            attrs: {
                              id: "exterior",
                              name: "exterior",
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.exterior,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "exterior", $$v)
                              },
                              expression: "model.exterior",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-2" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first(
                                "clienteComEntregaParaTerceiros"
                              ),
                              expression:
                                "errors.first('clienteComEntregaParaTerceiros')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "clienteComEntregaParaTerceiros" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.clienteComEntregaParaTerceiros"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("data-tooltip-component", {
                            attrs: {
                              text: _vm.$t(
                                "__.Crud.cliente.edit_vue_html.tooltipClienteComEntregaParaTerceiros"
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("checkbox-component", {
                            attrs: {
                              id: "clienteComEntregaParaTerceiros",
                              name: "clienteComEntregaParaTerceiros",
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.clienteComEntregaParaTerceiros,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "clienteComEntregaParaTerceiros",
                                  $$v
                                )
                              },
                              expression:
                                "model.clienteComEntregaParaTerceiros",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.model.tipoPessoa == _vm.tiposPessoa.Fisica ||
                              _vm.model.tipoPessoa ==
                                _vm.tiposPessoa.ProdutorRural,
                            expression:
                              "\n                            model.tipoPessoa == tiposPessoa.Fisica || model.tipoPessoa == tiposPessoa.ProdutorRural\n                        ",
                          },
                        ],
                        staticClass: "col-sm-4",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("nome"),
                                expression: "errors.first('nome')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: {
                                  for: "nome",
                                  title: _vm.$t("__.obrigatorio"),
                                },
                              },
                              [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.nome"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.model.nome,
                                  expression: "model.nome",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    rules: {
                                      max: 256,
                                      required:
                                        _vm.model.tipoPessoa ==
                                          _vm.tiposPessoa.Fisica ||
                                        _vm.model.tipoPessoa ==
                                          _vm.tiposPessoa.ProdutorRural,
                                    },
                                  },
                                  expression:
                                    "{\n                                    rules: {\n                                        max: 256,\n                                        required:\n                                            model.tipoPessoa == tiposPessoa.Fisica ||\n                                            model.tipoPessoa == tiposPessoa.ProdutorRural,\n                                    },\n                                }",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                autocomplete: "off",
                                type: "text",
                                id: "nome",
                                name: "nome",
                                disabled: _vm.somenteConsulta,
                              },
                              domProps: { value: _vm.model.nome },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.model,
                                    "nome",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica,
                            expression:
                              "model.tipoPessoa == tiposPessoa.Juridica",
                          },
                        ],
                        staticClass: "col-sm-4",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("nomeFantasia"),
                                expression: "errors.first('nomeFantasia')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: {
                                  for: "nomeFantasia",
                                  title: _vm.$t("__.obrigatorio"),
                                },
                              },
                              [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.MASCULINO"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.model.nomeFantasia,
                                  expression: "model.nomeFantasia",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    rules: {
                                      max: 256,
                                      required:
                                        _vm.model.tipoPessoa ==
                                        _vm.tiposPessoa.Juridica,
                                    },
                                  },
                                  expression:
                                    "{\n                                    rules: { max: 256, required: model.tipoPessoa == tiposPessoa.Juridica },\n                                }",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                autocomplete: "off",
                                type: "text",
                                id: "nomeFantasia",
                                name: "nomeFantasia",
                                disabled: _vm.somenteConsulta,
                              },
                              domProps: { value: _vm.model.nomeFantasia },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.model,
                                    "nomeFantasia",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("nomeRotulo"),
                              expression: "errors.first('nomeRotulo')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: {
                                for: "nomeRotulo",
                                title: _vm.$t("__.obrigatorio"),
                              },
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.nomeRotulo"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("data-tooltip-component", {
                            attrs: {
                              text: _vm.$t(
                                "__.Crud.cliente.edit_vue_html.nomeQueRotulo"
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.nomeRotulo,
                                expression: "model.nomeRotulo",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|max:256",
                                expression: "'required|max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "nomeRotulo",
                              name: "nomeRotulo",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.model.nomeRotulo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "nomeRotulo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("tipoCliente"),
                              expression: "errors.first('tipoCliente')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "tipoCliente" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.tipoCliente"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "tipoCliente",
                              name: "tipoCliente",
                              data: _vm.tipoClienteOptions,
                              searchable: false,
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.tipoCliente,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "tipoCliente", $$v)
                              },
                              expression: "model.tipoCliente",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-1" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("ativo"),
                              expression: "errors.first('ativo')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "ativo" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.ativo"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("checkbox-component", {
                            attrs: {
                              id: "ativo",
                              name: "ativo",
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.ativo,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "ativo", $$v)
                              },
                              expression: "model.ativo",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica
                      ? _c("div", { staticClass: "col-sm-8" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("razaoSocial"),
                                  expression: "errors.first('razaoSocial')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "razaoSocial",
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.razaoSocial"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.razaoSocial,
                                    expression: "model.razaoSocial",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        max: 256,
                                        required:
                                          _vm.model.tipoPessoa ==
                                          _vm.tiposPessoa.Juridica,
                                      },
                                    },
                                    expression:
                                      "{\n                                    rules: { max: 256, required: model.tipoPessoa == tiposPessoa.Juridica },\n                                }",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  id: "razaoSocial",
                                  name: "razaoSocial",
                                  disabled: _vm.somenteConsulta,
                                },
                                domProps: { value: _vm.model.razaoSocial },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "razaoSocial",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model.tipoPessoa == _vm.tiposPessoa.Juridica ||
                    _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                      ? _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("inscricaoMunicipal"),
                                  expression:
                                    "errors.first('inscricaoMunicipal')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "inscricaoMunicipal" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.im"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.inscricaoMunicipal,
                                    expression: "model.inscricaoMunicipal",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:20",
                                    expression: "'max:20'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  id: "inscricaoMunicipal",
                                  name: "inscricaoMunicipal",
                                  placeholder: "__________",
                                  disabled: _vm.somenteConsulta,
                                },
                                domProps: {
                                  value: _vm.model.inscricaoMunicipal,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "inscricaoMunicipal",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.model.tipoPessoa == _vm.tiposPessoa.Fisica ||
                  _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("dataNascimento"),
                                  expression: "errors.first('dataNascimento')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataNascimento" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.dataNasc"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  id: "dataNascimento",
                                  name: "dataNascimento",
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.dataNascimento,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "dataNascimento", $$v)
                                  },
                                  expression: "model.dataNascimento",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("genero"),
                                  expression: "errors.first('genero')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "genero",
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.genero"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required:
                                          _vm.model.tipoPessoa ==
                                            _vm.tiposPessoa.Fisica ||
                                          _vm.model.tipoPessoa ==
                                            _vm.tiposPessoa.ProdutorRural,
                                      },
                                    },
                                    expression:
                                      "{\n                                    rules: {\n                                        required:\n                                            model.tipoPessoa == tiposPessoa.Fisica ||\n                                            model.tipoPessoa == tiposPessoa.ProdutorRural,\n                                    },\n                                }",
                                  },
                                ],
                                attrs: {
                                  id: "genero",
                                  name: "genero",
                                  data: _vm.generosPessoaOptions,
                                  searchable: false,
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.genero,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "genero", $$v)
                                  },
                                  expression: "model.genero",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        (!_vm.model.exterior &&
                          _vm.model.tipoPessoa == _vm.tiposPessoa.Fisica) ||
                        _vm.model.tipoPessoa == _vm.tiposPessoa.ProdutorRural
                          ? _c("div", { staticClass: "col-sm-4" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.errors.first("rg"),
                                      expression: "errors.first('rg')",
                                    },
                                  ],
                                  staticClass: "form-group",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "rg" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              "__.Crud.cliente.edit_vue_html.rg"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.model.rg,
                                        expression: "model.rg",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "alpha_num|max:20",
                                        expression: "'alpha_num|max:20'",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      autocomplete: "off",
                                      type: "text",
                                      id: "rg",
                                      name: "rg",
                                      disabled: _vm.somenteConsulta,
                                    },
                                    domProps: { value: _vm.model.rg },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.model,
                                          "rg",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("orgaoExpedidor"),
                                  expression: "errors.first('orgaoExpedidor')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "orgaoExpedidor" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.orgaoExp"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.orgaoExpedidor,
                                    expression: "model.orgaoExpedidor",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "alpha_spaces|max:256",
                                    expression: "'alpha_spaces|max:256'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  id: "orgaoExpedidor",
                                  name: "orgaoExpedidor",
                                  disabled: _vm.somenteConsulta,
                                },
                                domProps: { value: _vm.model.orgaoExpedidor },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "orgaoExpedidor",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("ufExpedidor"),
                                  expression: "errors.first('ufExpedidor')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "ufExpedidor" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.ufExp"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "ufExpedidor",
                                  name: "ufExpedidor",
                                  data: _vm.ufOptions,
                                  searchable: true,
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.ufExpedidor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "ufExpedidor", $$v)
                                  },
                                  expression: "model.ufExpedidor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-8" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("observacao"),
                              expression: "errors.first('observacao')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "observacao" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("__.Crud.cliente.edit_vue_html.obs")
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("textarea-component", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:256",
                                expression: "'max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "observacao",
                              name: "observacao",
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.observacao,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "observacao", $$v)
                              },
                              expression: "model.observacao",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          _vm.isFranquiaHumana && !_vm.model.id
                            ? "col-sm-3"
                            : "col-sm-4",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("beneficio"),
                                expression: "errors.first('beneficio')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "beneficio" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.colaborador.edit_vue_html.beneficio"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              attrs: {
                                id: "beneficio",
                                name: "beneficio",
                                data: _vm.beneficiosOptions,
                                searchable: true,
                                refresh: _vm.atualizarBeneficios,
                              },
                              model: {
                                value: _vm.model.beneficioId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "beneficioId", $$v)
                                },
                                expression: "model.beneficioId",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isFranquiaHumana && !_vm.model.id
                      ? _c("div", { staticClass: "col-sm-1" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("pacienteCliente"),
                                  expression: "errors.first('pacienteCliente')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "pacienteCliente" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.paciente.edit_vue_html.pacienteCliente"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("checkbox-component", {
                                attrs: {
                                  id: "pacienteCliente",
                                  name: "pacienteCliente",
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.pacienteCliente,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "pacienteCliente", $$v)
                                  },
                                  expression: "model.pacienteCliente",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.localizacao"),
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows", id: "localizacao" }, slot: "rows" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("cep"),
                              expression: "errors.first('cep')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "cep" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("__.Crud.cliente.edit_vue_html.cep")
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("cep-field-component", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis ? "required|cep" : "cep",
                                expression:
                                  "isEstereis ? 'required|cep' : 'cep'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "cep",
                              name: "cep",
                              disabled: _vm.somenteConsulta,
                            },
                            on: {
                              "cep-changed": _vm.onCepChanged,
                              "cep-invalid": _vm.onCepInvalid,
                            },
                            model: {
                              value: _vm.model.cep,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "cep", $$v)
                              },
                              expression: "model.cep",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("estadoId"),
                              expression: "errors.first('estadoId')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "estadoId" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.estado"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis ? "required" : null,
                                expression: "isEstereis ? 'required' : null",
                              },
                            ],
                            attrs: {
                              id: "estadoId",
                              name: "estadoId",
                              data: _vm.ufOptions,
                              searchable: true,
                              disabled: _vm.somenteConsulta,
                            },
                            on: { input: _vm.onLoadCidades },
                            model: {
                              value: _vm.model.estadoId,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "estadoId", $$v)
                              },
                              expression: "model.estadoId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: _vm.model.exterior ? "col-sm-3" : "col-sm-6" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("cidadeId"),
                                expression: "errors.first('cidadeId')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "cidadeId" },
                              },
                              [
                                _vm.isEstereis
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.cidade"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.isEstereis ? "required" : null,
                                  expression: "isEstereis ? 'required' : null",
                                },
                              ],
                              attrs: {
                                id: "cidadeId",
                                name: "cidadeId",
                                data: _vm.cidadesOptions,
                                searchable: true,
                                disabled: _vm.somenteConsulta,
                              },
                              model: {
                                value: _vm.model.cidadeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "cidadeId", $$v)
                                },
                                expression: "model.cidadeId",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.model.exterior
                      ? _c("div", { staticClass: "col-sm-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("codigoPais"),
                                  expression: "errors.first('codigoPais')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "codigoPais",
                                    title: "* este campo é obrigatório",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                Pais\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "codigoPais",
                                  name: "codigoPais",
                                  data: _vm.paisesOptions,
                                  searchable: true,
                                  disabled: _vm.somenteConsulta,
                                },
                                model: {
                                  value: _vm.model.codigoPais,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "codigoPais", $$v)
                                  },
                                  expression: "model.codigoPais",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("endereco"),
                              expression: "errors.first('endereco')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "endereco" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.endereco"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.endereco,
                                expression: "model.endereco",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis
                                  ? "required|max:256"
                                  : "max:256",
                                expression:
                                  "isEstereis ? 'required|max:256' : 'max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "endereco",
                              name: "endereco",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.model.endereco },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "endereco",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("numero"),
                              expression: "errors.first('numero')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "numero" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("__.Crud.cliente.edit_vue_html.nro")
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.numero,
                                expression: "model.numero",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis
                                  ? "required|max:256"
                                  : "max:256",
                                expression:
                                  "isEstereis ? 'required|max:256' : 'max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "numero",
                              name: "numero",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.model.numero },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "numero",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("bairro"),
                              expression: "errors.first('bairro')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "bairro" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.bairro"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.bairro,
                                expression: "model.bairro",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis
                                  ? "required|max:256"
                                  : "max:256",
                                expression:
                                  "isEstereis ? 'required|max:256' : 'max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "bairro",
                              name: "bairro",
                              maxlength: "50",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.model.bairro },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "bairro",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("complemento"),
                              expression: "errors.first('complemento')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "complemento" },
                            },
                            [
                              _vm.isEstereis
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.complemento"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.complemento,
                                expression: "model.complemento",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isEstereis
                                  ? "required|max:256"
                                  : "max:256",
                                expression:
                                  "isEstereis ? 'required|max:256' : 'max:256'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "complemento",
                              name: "complemento",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.model.complemento },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "complemento",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.enderecoEntrega"),
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows", id: "entrega" }, slot: "rows" },
                [
                  !_vm.somenteConsulta
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btnCopiar",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.replicarLocalizacao()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.usarMesmoEnde"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.somenteConsulta
                    ? _c("endereco-entrega-component", {
                        ref: "enderecoEntregaComponent",
                        staticClass: "ignorePrint",
                        attrs: { clienteId: _vm.model.id },
                        on: {
                          "inclusao-endereco": _vm.onAdicionarEndereco,
                          "edicao-endereco": _vm.onEditEnderecoSubmit,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("grid-component", {
                    attrs: {
                      data: _vm.model.enderecosEntrega,
                      columns: _vm.gridColumnsEndereco,
                      "show-action-column": !_vm.somenteConsulta,
                      "show-table-foot": false,
                      "show-table-head": false,
                    },
                    on: {
                      "edit-item": _vm.onEditEndereco,
                      "remove-item": _vm.onRemoveEndereco,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.contato"),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("email"),
                            expression: "errors.first('email')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "email" },
                          },
                          [
                            _vm.isEstereis
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n                                E-mail\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.email,
                              expression: "model.email",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isEstereis
                                ? "required|email"
                                : "email",
                              expression:
                                "isEstereis ? 'required|email' : 'email'",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autocomplete: "off",
                            type: "email",
                            id: "email",
                            name: "email",
                            placeholder: "exemplo@exemplo.com.br",
                            disabled: _vm.somenteConsulta,
                          },
                          domProps: { value: _vm.model.email },
                          on: {
                            blur: _vm.onChangeEmail,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.model, "email", $event.target.value)
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.telefone"),
                collapsed: false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows", id: "contato" }, slot: "rows" },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("telefone"),
                                expression: "errors.first('telefone')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "telefone" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.telefone"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "mask-telefone",
                                  rawName: "v-mask-telefone",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.telefone,
                                  expression: "telefone",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "telefone",
                                  expression: "'telefone'",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                autocomplete: "off",
                                type: "text",
                                id: "telefone",
                                name: "telefone",
                                disabled: _vm.somenteConsulta,
                              },
                              domProps: { value: _vm.telefone },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.telefone = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("telefonePadrao"),
                                expression: "errors.first('telefonePadrao')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "telefonePadrao" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.telefonePadrao"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "telefonePadrao",
                                name: "telefonePadrao",
                                disabled: _vm.somenteConsulta,
                              },
                              model: {
                                value: _vm.telefonePadrao,
                                callback: function ($$v) {
                                  _vm.telefonePadrao = $$v
                                },
                                expression: "telefonePadrao",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.somenteConsulta
                        ? _c("buttonIncluirComponent", {
                            on: { click: _vm.onAddTelefone },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [
                          _c("grid-component", {
                            attrs: {
                              data: _vm.model.telefones,
                              columns: _vm.gridColumnsTelefones,
                              showRemoveItem: true,
                              showSortIcons: false,
                              showEditItem: false,
                              showTableHead: false,
                              showAddNewButton: false,
                              showTableFoot: false,
                              showTools: false,
                              showActionColumn: !_vm.somenteConsulta,
                            },
                            on: { "remove-item": _vm.onRemoverTelefone },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.cliente.edit_vue_html.emailsParaNotaFiscal"
                ),
                collapsed: false,
              },
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "rows", id: "emailNotaFiscal" },
                  slot: "rows",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("emailNotaFiscal"),
                              expression: "errors.first('emailNotaFiscal')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "emailNotaFiscal" },
                            },
                            [_vm._v("E-mail")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailNotaFiscal,
                                expression: "emailNotaFiscal",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "email",
                                expression: "'email'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "email",
                              id: "emailNotaFiscal",
                              name: "emailNotaFiscal",
                              placeholder: "exemplo@exemplo.com.br",
                              disabled: _vm.somenteConsulta,
                            },
                            domProps: { value: _vm.emailNotaFiscal },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.emailNotaFiscal = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.somenteConsulta
                    ? _c("buttonIncluirComponent", {
                        on: { click: _vm.onAddEmail },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("grid-component", {
                    attrs: {
                      data: _vm.model.emailsNotaFiscal,
                      columns: _vm.gridColumnsEmails,
                      showRemoveItem: true,
                      showSortIcons: false,
                      showEditItem: false,
                      showTableHead: false,
                      showAddNewButton: false,
                      showTableFoot: false,
                      showTools: false,
                      showActionColumn: !_vm.somenteConsulta,
                    },
                    on: { "remove-item": _vm.onRemoverEmail },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isFranquiaHumana
            ? _c(
                "fieldset-component",
                {
                  attrs: {
                    title: _vm.$t("__.Crud.cliente.edit_vue_html.pacientes"),
                    collapsed: true,
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "rows" }, slot: "rows" },
                    [
                      _c(
                        "shortcutComponent",
                        {
                          ref: "shortcutComponent",
                          attrs: {
                            showAddNew: false,
                            btOkName: _vm.$t("__.Crud.salvar"),
                          },
                          on: { "selection-item": _vm.onSavePaciente },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "component" }, slot: "component" },
                            [
                              _c("paciente-component", {
                                ref: "pacienteComponent",
                                attrs: {
                                  CalledByShortCut: true,
                                  showCliente: false,
                                },
                                on: { "paciente-model": _vm.onAddPacienteOk },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("grid-component", {
                        attrs: {
                          data: _vm.model.pacientes,
                          columns: _vm.gridColumns,
                          "show-action-column": !_vm.somenteConsulta,
                          "show-remove-item": false,
                          "show-table-foot": false,
                          "show-table-head": false,
                        },
                        on: { "edit-item": _vm.onVerPaciente },
                      }),
                      _vm._v(" "),
                      !_vm.somenteConsulta
                        ? _c("buttonIncluirComponent", {
                            on: { click: _vm.onVerPaciente },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t("__.Crud.cliente.edit_vue_html.fiscal"),
                collapsed: true,
              },
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "rows", id: "naturezaOperacaoId" },
                  slot: "rows",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first(
                                "naturezaOperacaoDentroEstadoId"
                              ),
                              expression:
                                "errors.first('naturezaOperacaoDentroEstadoId')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "naturezaOperacaoDentroEstadoId" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.natOperacaoDentroEstado"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "naturezaOperacaoDentroEstadoId",
                              name: "naturezaOperacaoDentroEstadoId",
                              data: _vm.naturezaOperacaoOptions,
                              searchable: true,
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.naturezaOperacaoDentroEstadoId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "naturezaOperacaoDentroEstadoId",
                                  $$v
                                )
                              },
                              expression:
                                "model.naturezaOperacaoDentroEstadoId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first(
                                "naturezaOperacaoForaEstadoId"
                              ),
                              expression:
                                "errors.first('naturezaOperacaoForaEstadoId')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "naturezaOperacaoForaEstadoId" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.natOperacaoForaEstado"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "naturezaOperacaoForaEstadoId",
                              name: "naturezaOperacaoForaEstadoId",
                              data: _vm.naturezaOperacaoOptions,
                              searchable: true,
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.naturezaOperacaoForaEstadoId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "naturezaOperacaoForaEstadoId",
                                  $$v
                                )
                              },
                              expression: "model.naturezaOperacaoForaEstadoId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("indicadorOperacao"),
                              expression: "errors.first('indicadorOperacao')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "indicadorOperacao" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.indicadorOperacao"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "indicadorOperacao",
                              name: "indicadorOperacao",
                              data: _vm.indicadorOperacaoOptions,
                              searchable: false,
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.indicadorOperacao,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "indicadorOperacao", $$v)
                              },
                              expression: "model.indicadorOperacao",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "issRetido" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.issRetido"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("checkbox-component", {
                            attrs: {
                              id: "issRetido",
                              name: "issRetido",
                              disabled: _vm.somenteConsulta,
                            },
                            model: {
                              value: _vm.model.issRetido,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "issRetido", $$v)
                              },
                              expression: "model.issRetido",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.cliente.edit_vue_html.produtoUsoEspecial"
                ),
                collapsed: true,
              },
            },
            [
              _c(
                "div",
                {
                  attrs: { slot: "rows", id: "produtoUsoEspecialId" },
                  slot: "rows",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("produtoUsoEspecialId"),
                              expression:
                                "errors.first('produtoUsoEspecialId')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "produtoUsoEspecialId" },
                            },
                            [_vm._v("Produtos")]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "'produtoUsoEspecialId'",
                              name: "'produtoUsoEspecialId'",
                              data: _vm.produtoUsoEspecialOptions,
                            },
                            model: {
                              value: _vm.produtoUsoEspecialId,
                              callback: function ($$v) {
                                _vm.produtoUsoEspecialId = $$v
                              },
                              expression: "produtoUsoEspecialId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.somenteConsulta
                    ? _c("buttonIncluirComponent", {
                        on: { click: _vm.onAddProdutosDeUsoEspecial },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("grid-component", {
                    attrs: {
                      data: _vm.model.produtosUsoEspecial,
                      columns: _vm.gridColumnsProdutosUsoEspecial,
                      showRemoveItem: true,
                      showSortIcons: false,
                      showEditItem: false,
                      showTableHead: false,
                      showAddNewButton: false,
                      showTableFoot: false,
                      showTools: false,
                      showActionColumn: !_vm.somenteConsulta,
                    },
                    on: { "remove-item": _vm.onRemoveProdutoUsoEspecial },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isEstereis
            ? _c(
                "fieldset-component",
                {
                  attrs: {
                    title: _vm.$t("__.Crud.cliente.edit_vue_html.cadSenior"),
                  },
                },
                [
                  _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteTributaICMS" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteTributaICMS"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteTributaICMS",
                                name: "clienteTributaICMS",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteTributaICMS,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "clienteTributaICMS", $$v)
                                },
                                expression: "model.clienteTributaICMS",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteTributaIPI" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteTributaIPI"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteTributaIPI",
                                name: "clienteTributaIPI",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteTributaIPI,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "clienteTributaIPI", $$v)
                                },
                                expression: "model.clienteTributaIPI",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteTributaPIS" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteTributaPIS"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteTributaPIS",
                                name: "clienteTributaPIS",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteTributaPIS,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "clienteTributaPIS", $$v)
                                },
                                expression: "model.clienteTributaPIS",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteTributaCOFINS" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteTributaCOFINS"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteTributaCOFINS",
                                name: "clienteTributaCOFINS",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteTributaCOFINS,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "clienteTributaCOFINS",
                                    $$v
                                  )
                                },
                                expression: "model.clienteTributaCOFINS",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteControlaRetencoes" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteControlaRetencoes"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteControlaRetencoes",
                                name: "clienteControlaRetencoes",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteControlaRetencoes,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "clienteControlaRetencoes",
                                    $$v
                                  )
                                },
                                expression: "model.clienteControlaRetencoes",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notaFiscaisRetencaoCOFINS" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.notaFiscaisRetencaoCOFINS"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "notaFiscaisRetencaoCOFINS",
                                name: "notaFiscaisRetencaoCOFINS",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.notaFiscaisRetencaoCOFINS,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "notaFiscaisRetencaoCOFINS",
                                    $$v
                                  )
                                },
                                expression: "model.notaFiscaisRetencaoCOFINS",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notaFiscaisRetencaoPIS" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.notaFiscaisRetencaoPIS"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "notaFiscaisRetencaoPIS",
                                name: "notaFiscaisRetencaoPIS",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.notaFiscaisRetencaoPIS,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "notaFiscaisRetencaoPIS",
                                    $$v
                                  )
                                },
                                expression: "model.notaFiscaisRetencaoPIS",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notaFiscaisRetencaoCSLL" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.notaFiscaisRetencaoCSLL"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "notaFiscaisRetencaoCSLL",
                                name: "notaFiscaisRetencaoCSLL",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.notaFiscaisRetencaoCSLL,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "notaFiscaisRetencaoCSLL",
                                    $$v
                                  )
                                },
                                expression: "model.notaFiscaisRetencaoCSLL",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notaFiscaisRetencaoIRRF" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.notaFiscaisRetencaoIRRF"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "notaFiscaisRetencaoIRRF",
                                name: "notaFiscaisRetencaoIRRF",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.notaFiscaisRetencaoIRRF,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "notaFiscaisRetencaoIRRF",
                                    $$v
                                  )
                                },
                                expression: "model.notaFiscaisRetencaoIRRF",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "notaFiscaisOutrasRetencoes" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.notaFiscaisOutrasRetencoes"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "notaFiscaisOutrasRetencoes",
                                name: "notaFiscaisOutrasRetencoes",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.notaFiscaisOutrasRetencoes,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "notaFiscaisOutrasRetencoes",
                                    $$v
                                  )
                                },
                                expression: "model.notaFiscaisOutrasRetencoes",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "clienteCooperado" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.clienteCooperado"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "clienteCooperado",
                                name: "clienteCooperado",
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.clienteCooperado,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "clienteCooperado", $$v)
                                },
                                expression: "model.clienteCooperado",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "numeroClienteSuframa" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.numeroClienteSuframa"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.numeroClienteSuframa,
                                expression: "model.numeroClienteSuframa",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              oninput:
                                "if (this.value.length > 10) this.value = this.value.slice(0, this.value.length - 1)",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: { value: _vm.model.numeroClienteSuframa },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "numeroClienteSuframa",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "codigoIBGECidade" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.codigoIBGECidade"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.codigoIBGECidade,
                                expression: "model.codigoIBGECidade",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              oninput:
                                "if (!Number(this.value) || this.value.length > 7) this.value = this.value.slice(0, this.value.length - 1)",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: { value: _vm.model.codigoIBGECidade },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "codigoIBGECidade",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "beneficioFiscal" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.beneficioFiscal"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              attrs: {
                                data: _vm.beneficioFiscalOptions,
                                searchable: false,
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.beneficioFiscal,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "beneficioFiscal", $$v)
                                },
                                expression: "model.beneficioFiscal",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: {
                                  for: "indicativoPresencialConsumidor",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.indicativoPresencialConsumidor"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              attrs: {
                                data: _vm.indicativoPresencialConsumidorOptions,
                                searchable: false,
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.indicativoPresencialConsumidor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "indicativoPresencialConsumidor",
                                    $$v
                                  )
                                },
                                expression:
                                  "model.indicativoPresencialConsumidor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.model
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.errors.first("freteCliente"),
                                    expression: "errors.first('freteCliente')",
                                  },
                                ],
                                staticClass: "form-group",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "freteCliente" },
                                  },
                                  [
                                    _vm.isEstereis
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.freteCliente"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.isEstereis ? "required" : null,
                                      expression:
                                        "isEstereis ? 'required' : null",
                                    },
                                  ],
                                  attrs: {
                                    id: "freteCliente",
                                    name: "freteCliente",
                                    data: _vm.freteClienteOptions,
                                    searchable: false,
                                    valueString: true,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.freteCliente,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "freteCliente", $$v)
                                    },
                                    expression: "model.freteCliente",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "contaContabilReduzida1" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.contaContabilReduzida1"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.contaContabilReduzida1,
                                    expression: "model.contaContabilReduzida1",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  oninput:
                                    "this.value = this.value.replace(/\\D/g, '').slice(0, 7)",
                                  disabled: _vm.bloqueiaEdicaoSenior,
                                },
                                domProps: {
                                  value: _vm.model.contaContabilReduzida1,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "contaContabilReduzida1",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "contaContabilReduzida2",
                                    title: "Adiantamento a Cliente",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.contaContabilReduzida2"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.contaContabilReduzida2,
                                    expression: "model.contaContabilReduzida2",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  oninput:
                                    "this.value = this.value.replace(/\\D/g, '').slice(0, 7)",
                                  disabled: _vm.bloqueiaEdicaoSenior,
                                },
                                domProps: {
                                  value: _vm.model.contaContabilReduzida2,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "contaContabilReduzida2",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "tipoAcerto" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.tipoAcerto"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.tipoAcertoOptions,
                                    searchable: false,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.tipoAcerto,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "tipoAcerto", $$v)
                                    },
                                    expression: "model.tipoAcerto",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "codigoRegimeTributario" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.codigoRegimeTributario"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.codigoRegimeTributarioOptions,
                                    searchable: false,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.codigoRegimeTributario,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "codigoRegimeTributario",
                                        $$v
                                      )
                                    },
                                    expression: "model.codigoRegimeTributario",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "naturezaRetencaoPisCofins" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.naturezaRetencaoPisCofins"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.naturezaRetencaoPisCofinsOptions,
                                    searchable: false,
                                    valueString: true,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.naturezaRetencaoPisCofins,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "naturezaRetencaoPisCofins",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.naturezaRetencaoPisCofins",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "tipoDireitoPropriedade" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.tipoDireitoPropriedade"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.tipoDireitoPropriedadeOptions,
                                    searchable: false,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.tipoDireitoPropriedade,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "tipoDireitoPropriedade",
                                        $$v
                                      )
                                    },
                                    expression: "model.tipoDireitoPropriedade",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "valorCalculoRetencao" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.valorCalculoRetencao"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.valorCalculoRetencaoOptions,
                                    searchable: false,
                                    valueString: true,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.valorCalculoRetencao,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "valorCalculoRetencao",
                                        $$v
                                      )
                                    },
                                    expression: "model.valorCalculoRetencao",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "codCondicaoPagamento" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.codCondicaoPagamento"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.codCondicaoPagamento,
                                    expression: "model.codCondicaoPagamento",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  oninput:
                                    "this.value = this.value.slice(0, 6)",
                                  disabled: _vm.bloqueiaEdicaoSenior,
                                },
                                domProps: {
                                  value: _vm.model.codCondicaoPagamento,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "codCondicaoPagamento",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "codRepresenteLegal" },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.codRepresenteLegal"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.model.codRepresenteLegal,
                                    expression: "model.codRepresenteLegal",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  autocomplete: "off",
                                  type: "text",
                                  oninput:
                                    "this.value = this.value.replace(/\\D/g, '').slice(0, 3)",
                                  disabled: _vm.bloqueiaEdicaoSenior,
                                },
                                domProps: {
                                  value: _vm.model.codRepresenteLegal,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.model,
                                      "codRepresenteLegal",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "cbsibsCliente" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.cbsibsCliente"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.cbsibsClienteOptions,
                                    searchable: false,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.cbsibsCliente,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "cbsibsCliente", $$v)
                                    },
                                    expression: "model.cbsibsCliente",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-3" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "tipoEnteGov" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Crud.cliente.edit_vue_html.tipoEnteGov"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  attrs: {
                                    data: _vm.tipoEnteGovOptions,
                                    searchable: false,
                                    disabled: _vm.bloqueiaEdicaoSenior,
                                  },
                                  model: {
                                    value: _vm.model.tipoEnteGov,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "tipoEnteGov", $$v)
                                    },
                                    expression: "model.tipoEnteGov",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "codRotaLocalidade" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.codRotaLocalidade"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.codRotaLocalidade,
                                expression: "model.codRotaLocalidade",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "codRotaLocalidade",
                              name: "codRotaLocalidade",
                              maxlength: "3",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: { value: _vm.model.codRotaLocalidade },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "codRotaLocalidade",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "seqRotaLocalidade" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.seqRotaLocalidade"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.seqRotaLocalidade,
                                expression: "model.seqRotaLocalidade",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "number",
                              id: "seqRotaLocalidade",
                              name: "seqRotaLocalidade",
                              oninput:
                                "if (this.value.length > 4) this.value = this.value.slice(0, 4)",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: { value: _vm.model.seqRotaLocalidade },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "seqRotaLocalidade",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "codSubRota" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.codSubRota"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.codSubRota,
                                expression: "model.codSubRota",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "codSubRota",
                              name: "codSubRota",
                              maxlength: "3",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: { value: _vm.model.codSubRota },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "codSubRota",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("tipoMercado"),
                                expression: "errors.first('tipoMercado')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "tipoMercado" },
                              },
                              [
                                _vm.isEstereis
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.cliente.edit_vue_html.tipoMercado"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.isEstereis ? "required" : null,
                                  expression: "isEstereis ? 'required' : null",
                                },
                              ],
                              attrs: {
                                id: "tipoMercado",
                                name: "tipoMercado",
                                data: _vm.tipoMercadoOptions,
                                searchable: false,
                                disabled: _vm.bloqueiaEdicaoSenior,
                              },
                              model: {
                                value: _vm.model.tipoMercado,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "tipoMercado", $$v)
                                },
                                expression: "model.tipoMercado",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "codRepresentantePadrao" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.cliente.edit_vue_html.codRepresentantePadrao"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.model.codRepresentantePadrao,
                                expression: "model.codRepresentantePadrao",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              id: "codRepresentantePadrao",
                              name: "codRepresentantePadrao",
                              oninput:
                                "this.value = this.value.replace(/\\D/g, '').slice(0, 3)",
                              disabled: _vm.bloqueiaEdicaoSenior,
                            },
                            domProps: {
                              value: _vm.model.codRepresentantePadrao,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.model,
                                  "codRepresentantePadrao",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.model.id
            ? _c("infoBagdeComponent", { attrs: { text: _vm.infoBagdeText } })
            : _vm._e(),
          _vm._v(" "),
          _vm.validarVisibilidadeBotoes("replicar-filiais")
            ? [
                _c("replicar-selecao-franquia-filiais-component", {
                  ref: "replicarSelecaoFranquiaFiliaisComponent",
                  attrs: { showFiliais: true },
                  on: { "replicar-filiais": _vm.onConfirmReplicar },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("fieldset", [
            !_vm.hideExtras
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12 newbtn" }, [
                    _c("div", { staticClass: "form-group" }, [
                      !_vm.somenteConsulta
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { type: "submit" },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-save",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("__.Crud.salvar")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.somenteConsulta
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.load()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("__.Crud.limpar")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.cancel()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.voltar")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("vendas-cliente-list-component", {
        ref: "vendasClienteListComponent",
      }),
      _vm._v(" "),
      _c("uploadAnexoComponent", {
        ref: "uploadAnexoComponent",
        attrs: { id: _vm.model.id, serviceUpload: "ClienteAnexo" },
      }),
      _vm._v(" "),
      _c("informacoesAdicionaisRepresentanteListComponent", {
        ref: "informacoesAdicionaisRepresentanteListComponent",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }